module.exports = __webpack_public_path__ + "img/avbg.37c3ea6b.png";